"use strict";

angular.module("vendor")
.controller("treeIndustrySelectorController", function($scope, $attrs, $filter, treeOptions, close, IndustryService) {
    var selectedIndustryIds = IndustryService.getIds($attrs.selectedIndustries);

    this.tree = $attrs.tree;
    this.selected = {};
    this.expanded = [];

    this.options = {
        dirSelectable: false,
        allowDeselect: false,
        injectClasses: {
            iExpanded: "fa fa-minus-square",
            iCollapsed: "fa fa-plus-square",
            iLeaf: "fa fa-tag"
        },
        isSelectable: function(node) {
            return selectedIndustryIds.indexOf(node.id) === -1;
        }
    };
    _.extend(this.options, treeOptions);

    this.onToggle = function(node, expanded) {
        var index = this.expanded.indexOf(node);
        if (index > -1) {
            this.expanded.splice(index, 1);
        }
        if (expanded) {
            this.expanded.push(node);
        }
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.cancel = function() {
        this.close();
    };

    this.select = function() {
        this.close(this.selected);
    };

    this.isEmpty = function() {
        var selected = this.selected;
        for (var prop in selected) {
            if (selected.hasOwnProperty(prop))
                return false;
        }
        return true;
    };

    this.isValid = function() {
        return this.selected !== undefined && !this.isEmpty();
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/mptt-industry-selector/mptt-industry-selector.modal.js
// module id = 810
// module chunks = 0